module.exports = __webpack_public_path__ + "media/images/patent/x_3-9b2bb44ce9f78839b127a26c7093a671.png";